import { Button, Popover, PopoverInteractionKind, Position, Size } from "@blueprintjs/core"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store" 
import MeatSelectorList from "./MeatSelectorList"
import createMeat from "./utils/createMeat"
import getNewMeatTitle from "./utils/getNewMeatTitle"
import { __, getID } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import updateHistory from "./utils/updateHistory"
import { MouseEvent } from "react"
import { defaultSection } from "src/modules/pe-landing-module/data/defaults/defaultSection"

/* Protopia Ecosystem component */
export interface ISectionEditProps {
    section?: ILandingSection
    i: number
    isLast?: boolean
}
const SectionAddButton = (props: ISectionEditProps): JSX.Element => {
    const currentLanding:ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)    
    const onNewSection = ( evt: MouseEvent, key: string, n: number = 0,  ) => { 
        let newLanding = { ...currentLanding }
        const newSection = defaultSection()
        const historyStep: IHistoryStep = {
            data: {
                ...newSection,
                id: getID( key ),
                title: {
                    ...newSection.title,
                    text: evt.ctrlKey ? "" : getNewMeatTitle( key, n )[0], 
                },
                description: {
                    ...newSection.description,
                    text: evt.ctrlKey ? "" : getNewMeatTitle( key, n )[1], 
                },
                data: [
                    createMeat( key, n, {} ) 
                ],
                delimiter: { ...currentLanding.delimiter }
            },
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : __("Add new section ") + components()[key].title,
        }
        newLanding.sections.splice(
            props.i, 
            0, 
            historyStep.data,
        )
        updateHistory( historyStep, newLanding )
    }
    return <>
        <div className='landing-section-edit-container'>
            <Popover 
                position={ Position.BOTTOM_LEFT }
                interactionKind={ PopoverInteractionKind.CLICK }
                content={ <MeatSelectorList onClick={onNewSection} /> } 
                portalClassName="z-index-130" 
                className={`edit-button-popover ${ props.isLast ? "" : "pe-surface2" }`}
            >
                <Button 
                    icon="plus" 
                    className="edit-button" 
                    size={ Size.SMALL }
                >
                    
                </Button>
            </Popover>       
        </div>  
    </>
}
export default SectionAddButton